import React from 'react';
import { StarIcon } from 'lucide-react';
interface Testimonial {
  name: string;
  age: number;
  province: string;
  quote: string;
}
function TestimonialCard({
  name,
  age,
  province,
  quote
}: Testimonial) {
  return <div className="bg-white rounded-xl shadow-md border border-gray-100 p-6" data-id="element-271">
      <div className="flex gap-1 mb-3" data-id="element-272">
        <StarIcon className="w-5 h-5 fill-amber-400 text-amber-400" data-id="element-273" />
        <StarIcon className="w-5 h-5 fill-amber-400 text-amber-400" data-id="element-274" />
        <StarIcon className="w-5 h-5 fill-amber-400 text-amber-400" data-id="element-275" />
        <StarIcon className="w-5 h-5 fill-amber-400 text-amber-400" data-id="element-276" />
        <StarIcon className="w-5 h-5 fill-amber-400 text-amber-400" data-id="element-277" />
      </div>
      <p className="text-gray-700 italic mb-4 leading-relaxed" data-id="element-278">"{quote}"</p>
      <div className="flex items-center gap-3" data-id="element-279">
        <div className="w-10 h-10 bg-amber-500 rounded-full flex items-center justify-center" data-id="element-280">
          <span className="text-white font-bold text-sm" data-id="element-281">{name.charAt(0)}</span>
        </div>
        <div data-id="element-282">
          <p className="font-bold text-gray-900 text-sm" data-id="element-283">{name}</p>
          <p className="text-gray-500 text-xs" data-id="element-284">
            {age} años – {province}
          </p>
        </div>
      </div>
    </div>;
}
export function TestimonialSection() {
  return <section className="bg-gray-50 py-16 md:py-20 px-4" data-id="element-285">
      <div className="max-w-5xl mx-auto" data-id="element-286">
        <h2 className="font-heading text-3xl md:text-4xl font-bold text-center text-gray-900 mb-12" data-id="element-287">
          ⭐ Lo que dicen nuestros alumnos
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-288">
          <TestimonialCard name="Carlos M." age={42} province="Buenos Aires" quote="Llevaba 15 años soldando y nunca había tenido planos tan claros. En el primer mes fabriqué una escalera caracol que me dejó $180.000 de ganancia. Antes ni me animaba a presupuestarla." data-id="element-289" />
          <TestimonialCard name="Roberto S." age={35} province="Córdoba" quote="Tenía un tallercito chico y hacía rejas nomás. Con los planos del Mega Pack empecé a hacer muebles industriales y portones. Hoy facturo el triple y tengo lista de espera." data-id="element-290" />
          <TestimonialCard name="Martín G." age={28} province="Mendoza" quote="Arranqué de cero, sin experiencia. Los planos con medidas exactas me ahorraron meses de prueba y error. Ya tengo mi propio taller y vivo de esto. Mejor inversión imposible." data-id="element-291" />
          <TestimonialCard name="Jorge P." age={51} province="Santa Fe" quote="Soy herrero de toda la vida pero estaba estancado. El pack me abrió la cabeza con los proyectos de alto ticket. Ahora hago trabajos más grandes y cobro lo que corresponde." data-id="element-292" />
          <TestimonialCard name="Diego L." age={38} province="Tucumán" quote="El taller era de mi viejo y yo no sabía cómo hacerlo crecer. Con la guía de presupuestos aprendí a cobrar bien y con los planos premium entré en el nicho de máquinas de gym. Cambió todo." data-id="element-293" />
        </div>
      </div>
    </section>;
}